import { isShowEvent } from 'src/config/event/utils';
import { SampleGptButton } from '../SampleGptButton';
import { GPTGameLauncher } from 'src/EXPERIMENTAL_LIB/gpt/games';
import { useModalContext } from 'src/hooks/useModalContext';
import { WheelOfFortuneEventIcon } from 'src/config/assets/gptEventIcons/WheelOfFortuneEventIcon';

export const GPTWheelOfFortuneButton = () => {
  const { openModal } = useModalContext();
  const handleRegistration = () => {
    openModal('SIGNUP', { props: { hideWhyNot: true } });
  };

  const isSpinAdditional = isShowEvent('SPIN_ADDITIONAL');
  const isGPTEvent = isShowEvent('GPT_GAMES');

  const eventBadgeTitle = (() => {
    if (!isGPTEvent) return;
    return isSpinAdditional ? '-40%' : '-20%';
  })();

  return (
    <GPTGameLauncher
      gameName="wheelOfFortune"
      renderButton={({ Icon, title, ...props }) => (
        <SampleGptButton
          {...props}
          Icon={isGPTEvent ? WheelOfFortuneEventIcon : Icon}
          title={isGPTEvent ? 'gpt.wheelOfFortuneEventTitle' : title}
          badgeContent={eventBadgeTitle}
        />
      )}
      openRegistration={handleRegistration}
    />
  );
};
